export default __webpack_public_path__ + "static/media/login-background.844d5ff9.png";